import { InputContainer } from 'styles'
import { useState, useEffect, useRef, useContext } from 'react'
import { useField } from '@unform/core'
import { IMask } from 'react-imask'
import { UserContext } from 'context/userContext'
import { loadingOrange } from 'assets/Icons'
import { InputError, MaskedInput, Span, Row, Loading } from './style'

interface IInputProps {
  rounded?: boolean
  small?: boolean
  medium?: boolean
  xsmall?: boolean
  xxsmall?: boolean
  large?: boolean
  icon?: boolean
  error?: string
  marginRight?: number
  smallPad?: boolean
  name: string
  unmask?: boolean
  // handleChange?: (_ev: any) => void
  handleChange?: any
  handleCreated?: (_ref: any, _name: string) => void
  onBlur?: (_ev: any) => void
  initialError?: string
  placeholder?: string
  disabled?: boolean
  defaultValue?: string | number | undefined | null
  type: string
  getUnmaskedValue?: any
  uniqKey?: any
  loading?: boolean
  customError?: string
}

const getCurrent18 = () => {
  const now = new Date()
  return now.getFullYear() - 18
}

export default function MaskedInputComponent({
  name,
  initialError,
  handleChange,
  handleCreated,
  type,
  placeholder,
  defaultValue,
  unmask = false,
  uniqKey,
  onBlur,
  loading,
  customError,
  ...rest
}: IInputProps) {
  // const { fieldName, registerField, error } = useField(name)
  const { retroData } = useContext(UserContext)
  const inputRef = useRef<any>(null)
  const [Erro, setErro] = useState(initialError)
  const [label, setLabel] = useState(false)
  const { fieldName, registerField, error, clearError } = useField(name)

  // useEffect(() => {
  //   console.log('ref do input', inputRef.current.value)
  //   inputRef.current.value = ''
  // }, [])
  const handleBlur = () => {
    onBlur && onBlur(inputRef.current?.value)
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.value
      },
      setValue: (ref, value) => {
        console.log('lalalla sobre build')
        if (value) return setLabel(true)
        ref.current.value = value
      },
      clearValue: (ref) => {
        ref.current.value = ''
      },
    })
  }, [fieldName, registerField])

  const showInput = (tp = 'text') => {
    const input =
      {
        number: [
          {
            mask: 'num',
            blocks: {
              num: {
                mask: Number,
                radix: ',',
                mapToRadix: [','], // accepts both '.' and ',' but maps to '.'
                scale: 2,
                signed: false,
                thousandsSeparator: '.',
                padFractionalZeros: false,
                normalizeZeros: true,
                min: 0,
                max: Number.MAX_SAFE_INTEGER,
              },
            },
          },
        ],
        money: [
          {
            mask: 'R$ num',
            blocks: {
              num: {
                mask: Number,
                radix: ',',
                mapToRadix: [','], // accepts both '.' and ',' but maps to '.'
                scale: 2,
                signed: false,
                thousandsSeparator: '.',
                padFractionalZeros: true,
                normalizeZeros: true,
                min: 0,
                max: Number.MAX_SAFE_INTEGER,
              },
            },
          },
        ],
        text: [null],
        cpf: ['000.000.000-00'],
        rg: ['00.000.000-00'],
        cnpj: ['00.000.000/0000-00'],
        cell: ['(00) 00000-0000'],
        cep: ['00000-000'],
        cellWithInternational: ['+55 (00) 00000-0000'],
        deadline: ['00 meses'],
        jurosaa: [
          {
            mask: 'num',
            blocks: {
              num: {
                mask: Number,
                scale: 2,
                signed: false,
                radix: ',',
                mapToRadix: [','],
                min: 0,
                max: 100,
                normalizeZeros: true,
                padFractionalZeros: true,
                suffix: '% a.a.',
              },
            },
          },
        ],
        percent: [
          {
            mask: Number,
            scale: 2,
            signed: false,
            radix: '.',
            mapToRadix: ['.'],
            min: 0,
            max: 100,
            normalizeZeros: true,
            padFractionalZeros: true,
            suffix: '%',
          },
        ],
        birthday: [
          'd/m/Y',
          {
            d: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 31,
              maxLength: 2,
            },
            m: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 12,
              maxLength: 2,
            },
            Y: {
              mask: IMask.MaskedRange,
              from: 1900,
              to: getCurrent18(),
            },
          },
        ],
        date: [
          'd/m/Y',
          {
            d: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 31,
              maxLength: 2,
            },
            m: {
              mask: IMask.MaskedRange,
              from: 1,
              to: 12,
              maxLength: 2,
            },
            Y: {
              mask: IMask.MaskedRange,
              from: 1900,
              to: 2200,
            },
          },
        ],
      }[tp] || []

    // máscara, regras
    const [mask, blocks] = input

    const alternative = tp === 'money' || tp === 'number' || tp === 'jurosaa'

    if (alternative) {
      return (
        <MaskedInput
          onFocus={clearError}
          ref={inputRef}
          mask={input}
          onBlur={handleBlur}
          onPaste={(e) => {
            handleChange(e)
          }}
          placeholder={placeholder}
          className="masked-input"
          name={name}
          defaultValue={defaultValue}
          error={Erro}
          unmask
          lazy={false}
          key={uniqKey}
          onAccept={(value) => {
            clearError()
            handleChange(value)
          }}
          {...rest}
        />
      )
    }

    return (
      <MaskedInput
        onFocus={clearError}
        ref={inputRef}
        onChange={(e) => {
          clearError()
          handleChange(e)
        }}
        onPaste={(e) => {
          clearError()
          handleChange(e)
        }}
        onBlur={handleBlur}
        placeholder={placeholder}
        className="masked-input"
        mask={mask}
        blocks={blocks}
        defaultValue={defaultValue}
        name={name}
        error={Erro}
        key={uniqKey}
        {...rest}
      />
    )
  }

  useEffect(() => {
    setErro(error)
  }, [error])

  useEffect(() => {
    setErro(customError)
  }, [customError])

  return (
    <InputContainer>
      {defaultValue || inputRef?.current?.value ? (
        <Span>{placeholder}</Span>
      ) : (
        <div />
      )}
      <Row>
        {showInput(type)}
        {/* <span className="asterisco">*</span> */}
      </Row>
      {Erro && <InputError {...rest}>{Erro}</InputError>}

      <Loading loading={loading}>
        <img className="loading-img" src={loadingOrange} alt="loading" />
      </Loading>
    </InputContainer>
  )
}
